import { render, staticRenderFns } from "./DocenteChatIa.vue?vue&type=template&id=8b3b19c6&scoped=true"
import script from "./DocenteChatIa.vue?vue&type=script&lang=js"
export * from "./DocenteChatIa.vue?vue&type=script&lang=js"
import style0 from "./DocenteChatIa.vue?vue&type=style&index=0&id=8b3b19c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3b19c6",
  null
  
)

export default component.exports